import styled, { css } from 'styled-components';

const PeriodButton = styled.li`
    margin: 0 5px;
    padding: 5px;
    text-align: center;
    border: 1px solid #0183da;
    background-color: ${({ theme }) => theme.Surface.primary};
    color: #0183da;
    border-radius: 4px;
    display: inline-block;
    min-width: 80px;
    cursor: pointer;

    &:hover {
        background-color: #0183da;
        color: ${({ theme }) => theme.Text.OppositeSurface.primary};
    }

    ${(props) =>
        props.active &&
        css`
            background-color: #0183da;
            color: ${({ theme }) => theme.Text.OppositeSurface.primary};
        `}
`;

export default PeriodButton;
